import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { UpdateEmployeeWorkDayHoursMutation } from './update-employee-work-day-hours.mutation';
export const { useSubscribableMutation: useUpdateEmployeeWorkDayHours, useSubscribeMutationResult: useUpdateEmployeeWorkDayHoursResult, } = createSubscribableMutator(UpdateEmployeeWorkDayHoursMutation);
